import React from "react";
import PropTypes from "prop-types";
import TopNav from "./TopNav";
import { DomainScopes } from "../../constants/DomainConstants";
import Row from "../common/Row";

const PageHeader = ({ title, intro, showTopNav, topNavTabSettings, scope, subTitle }) => {
	const titleItem = title ? <h1 className="page-title">{title}</h1> : null;
	const subTitleItem = subTitle ? <span className="page-subtitle">Dossier: {subTitle}</span> : null;
	const introItem = intro ? scope === DomainScopes.ZOEKMOTOR ? <Row>{intro}</Row> : <div className="page-subtitle">{intro}</div> : null;
	const topNavItem = showTopNav ?
		<TopNav topNavTabSettings={topNavTabSettings} scope={scope} /> : null;

	return (
		<section className="o-page__header">
			<div className="c-container u-clear">
				<div className="o-page__header__section">
					{titleItem}
					{subTitleItem}
					{introItem}
				</div>
				{topNavItem}
			</div>
		</section>
	);
};

PageHeader.propTypes = {
	title: PropTypes.node,
	intro: PropTypes.string,
	showTopNav: PropTypes.bool.isRequired,
	topNavTabSettings: PropTypes.object.isRequired,
	scope: PropTypes.string,
	svlDossierId: PropTypes.string
};

export default PageHeader;
